var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col",attrs:{"id":"app"}},[(!_vm.isFullscreen)?_c('TheHeader'):_vm._e(),_c('router-view',{staticClass:"flex-1"}),(!_vm.isFullscreen)?_c('TheFooter'):_vm._e(),(!_vm.isFullscreen)?_c('WhatsAppButton'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }